import {createRootContextHook} from 'common/util/react';

export const useCustomProperties = createRootContextHook(`customProperties`);
